export const AUDIENCIA_GROUP = 'AUDIENCIA';
export const IMPUTADO_GROUP = 'IMPUTADO';

export default [
    {
        id: 0,
        descripcion: 'AUDIENCIA'
    },
    {
        id: 1,
        descripcion: 'IMPUTADO'
    }
];